import CardGiftCardV2 from 'assets/Icons/cardGiftCardV2';
import CardProductV2 from 'assets/Icons/cardProductV2';
import CardServiceIconV2 from 'assets/Icons/cardServiceIconV2';
import Box from 'components/Box';
import Text from 'components/Text';
import reportSelectors from 'features/report/services/selectors';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import IncomeChart from './IncomeChart';
import SummaryItem from './SummaryItem';

const Sale = () => {
  const summarySalon = reportSelectors.getSummarySalon();
  return (
    <Container>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Text variant='H7' color='text_3'>
          Sales
        </Text>
        <TotalBox>
          <Text variant='CONTENT_3'>Total:</Text>
          <Text variant='H5' color='v2_secondary_3'>
            {formatCurrency(
              summarySalon?.totalSaleService + summarySalon?.totalSaleProduct + summarySalon?.totalSaleGiftCard,
            ) || '$0.00'}
          </Text>
        </TotalBox>
      </Box>
      <Box display='flex' gap='4'>
        <IncomeChart data={summarySalon} />
        <Box display='flex' flexDirection='column' style={{ flex: 1 }}>
          <SummaryItem
            icon={<CardServiceIconV2 width={24} height={24} />}
            label='Services'
            value={formatCurrency(summarySalon?.totalSaleService || 0)}
            bgColor='#EFFFFA'
          />
          <SummaryItem
            icon={<CardProductV2 width={24} height={24} />}
            label='Products'
            value={formatCurrency(summarySalon?.totalSaleProduct || 0)}
            bgColor='#F1EFFF'
          />
          <SummaryItem
            icon={<CardGiftCardV2 width={24} height={24} />}
            label='Gift Cards'
            value={formatCurrency(summarySalon?.totalSaleGiftCard || 0)}
            bgColor='#EFFFFA'
          />
        </Box>
      </Box>
    </Container>
  );
};

export default Sale;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e9edf2;
  background: #fff;
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.15);
  font-family: Poppins;
`;

const TotalBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 4px 8px;
  background: #e4f4f6;
  border-radius: 8px;
`;

